import React from "react";
import { Building2 } from "lucide-react";

const sumLastNDays = (series, n) =>
  series.slice(-n).reduce((acc, item) => acc + (item.count || 0), 0);

export default function GrowthBadges({ trends }) {
  const customerGrowth = trends?.growth?.schools || [];

  if (customerGrowth.length === 0) return null;

  const newCustomersThisWeek = sumLastNDays(customerGrowth, 7);

  return (
    <div className="flex flex-wrap gap-3">
      <span className="inline-flex items-center gap-2 rounded-xl border border-gray-100 bg-white px-4 py-2 text-sm shadow-sm">
        <Building2 className="h-4 w-4 text-blue-600" />
        <strong className="tabular-nums">{newCustomersThisWeek}</strong> new customers this week
      </span>
    </div>
  );
}
